<template>
  <div class="mt-md-8">
    <v-container v-if="sm">
      <Banner type="top" />
    </v-container>
    <Featured />
    <div class="grey lighten-4">
      <v-container class="py-10">
        <CategoriesTop />
      </v-container>
    </div>
    <v-container class="my-7">
      <grid-container class="mb-8" cols="auto" cols-sm="1fr 1fr" gap="30px">
        <Banner type="center-1-a" />
        <Banner type="center-1-b" />
      </grid-container>
      <grid-container cols="auto" cols-sm="2fr 1fr" gap="30px">
        <CategoryCenter />
        <div>
          <MostRead />
          <Banner type="right-a" />
        </div>
      </grid-container>
      <Banner type="center-2" class="mt-8" />
    </v-container>
    <div class="secondary">
      <v-container class="py-10">
        <Videos />
      </v-container>
    </div>
    <div class="grey lighten-4">
      <v-container class="py-10">
        <grid-container class="my-8" cols="auto" cols-sm="1fr 1fr" gap="30px">
          <Banner type="bottom-a" />
          <Banner type="bottom-b" />
        </grid-container>
        <CategoriesBottom />
      </v-container>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/cards/Banner.vue";
import Featured from "./Featured.vue";
import CategoriesTop from "./CategoriesTop.vue";
import CategoryCenter from "./CategoryCenter.vue";
import Videos from "./Videos.vue";
import CategoriesBottom from "./CategoriesBottom.vue";
import MostRead from "@/components/widgets/MostRead.vue";

export default {
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Banner,
    Featured,
    CategoriesTop,
    CategoryCenter,
    Videos,
    CategoriesBottom,
    MostRead,
  },
};
</script>
